import { serviceMaker, methods, api } from "@/http/index.js";

export const getdiscount = () =>
  serviceMaker(`/discount`, methods.GET, api.NGB);

export const getpromotioncode = () =>
  serviceMaker(`/promotioncode`, methods.GET, api.NGB);

export const getviewDiscount = (id) =>
  serviceMaker(`/discount/${id}`, methods.GET, api.NGB);

export const getviewPromotion = (id) =>
  serviceMaker(`/promotioncode/${id}`, methods.GET, api.NGB);

export const getDiscountTemplate = () =>
  serviceMaker(`/discount/template`, methods.GET, api.NGB);

export const getPromotioncodeTemplate = () =>
  serviceMaker(`/promotioncode/template`, methods.GET, api.NGB);

export const deleteDiscount = (id) =>
  serviceMaker(`/discount/${id}`, methods.DELETE, api.NGB);

export const deletePromotioncode = (id) =>
  serviceMaker(`/promotioncode/${id}`, methods.DELETE, api.NGB);

export const creatediscount = (data) =>
  serviceMaker(`/discount`, methods.POST, api.NGB, data);

export const createpromotioncode = (data) =>
  serviceMaker(`/promotioncode`, methods.POST, api.NGB, data);

export const editpromotioncode = (id, data) =>
  serviceMaker(`/promotioncode/${id}`, methods.PUT, api.NGB, data);

export const editViewPromotionCode = (id) =>
  serviceMaker(`/promotioncode/${id}?template=true`, methods.GET, api.NGB);

export const editViewdiscount = (id) =>
  serviceMaker(`/discount/${id}?template=true`, methods.GET, api.NGB);

export const editdiscount = (id, data) =>
  serviceMaker(`/discount/${id}`, methods.PUT, api.NGB, data);
